import React from "react";
import {
  MosaicLayout,
  MosaicLayoutProps,
  cardImageRatioForMosaicIndex
} from "@silversea-ssc/ui-components-react";
import AsCardSlide from "components/Card/AsCardSlide";
import { isPresent } from "src/utils/checks";
import { CollectionMosaicSpecialVoyageFragment } from "types/graphql-types";

type Props = MosaicLayoutProps & {
  data: CollectionMosaicSpecialVoyageFragment[];
};

const GrandVoyagesMosaic: React.FC<Props> = ({ data, ...props }) => {
  const crises = data.filter((c) => isPresent(c) && isPresent(c.card));

  return (
    <MosaicLayout {...props} data-content-name="grand_voyages_mosaic">
      {crises.map((item, index) => {
        const cardRatio = cardImageRatioForMosaicIndex(props.variant, index);
        return (
          <AsCardSlide
            key={item._id}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            card={item.card!}
            imageRatio={cardRatio}
            fullPath={item.fullPath}
            cardBackgroundColor="white"
            trackingName={item.metadata?.tracking?.name}
          />
        );
      })}
    </MosaicLayout>
  );
};

export default GrandVoyagesMosaic;
